import { Alert, AlertDescription, AlertTitle } from "@nwga/ui/components/alert";
import { Button } from "@nwga/ui/components/button";
import { AlertTriangleIcon } from "lucide-react";

/**
 * The failure state for a route or a query.
 *
 * Shows the server's message when there is one — the API only exposes messages
 * for errors it has already decided are safe to show (`AppError.isExposed`),
 * and internal failures arrive pre-replaced with a generic string.
 */
export function ErrorState({
	error,
	onRetry,
}: {
	error: unknown;
	onRetry?: () => void;
}) {
	const message =
		error instanceof Error && error.message.length > 0
			? error.message
			: "Something went wrong. Please try again.";

	return (
		<Alert variant="destructive">
			<AlertTriangleIcon className="size-4" />
			<AlertTitle>Something went wrong</AlertTitle>
			<AlertDescription className="space-y-3">
				<p>{message}</p>
				{onRetry !== undefined && (
					<Button variant="outline" size="sm" onClick={onRetry}>
						Try again
					</Button>
				)}
			</AlertDescription>
		</Alert>
	);
}
